<template>
  <div class="show-play-button">
    <el-progress
      v-show="audioIcon === 'play' || audioIcon === 'pause' || isLoading"
      :percentage="Number(episodeProgress)"
      :stroke-width="2"
      :width="42"
      :show-text="false"
      type="circle"
      color="#00AECB" />
    <svg v-if="audioIcon === 'play'" class="play-button" svg-inline="" @click="playEpisode" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 121 156"><defs><path id="ic_play_blue_svg__a" d="M496.406096,345.69723 C491.541695,349.359203 485.132833,350.027479 479.65336,347.444103 C474.173887,344.860725 470.480935,339.429801 470,333.247692 L470,208.752308 C470.480935,202.570199 474.173887,197.139275 479.65336,194.555898 C485.132833,191.972521 491.541695,192.640797 496.406096,196.30277 L584.381047,258.550462 C588.505275,261.268282 591,265.960591 591,271 C591,276.039409 588.505275,280.731718 584.381047,283.449538 L496.406096,345.69723 Z"/></defs><g fill="none" fill-rule="evenodd"><g transform="translate(-470.000000, -193.000000)"><use fill="#00AECB" xlink:href="#ic_play_blue_svg__a"/></g></g></svg>
    <svg v-if="audioIcon === 'pause'" class="pause-button" svg-inline="" @click="pauseEpisode" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 24"><g fill="none" fill-rule="evenodd"><g fill="#00AECB" fill-rule="nonzero"><g><path d="M1.666667,0 L6.333334,0 C6.885618,0 7.333334,0.447715 7.333334,1 L7.333334,23 C7.333334,23.552285 6.885618,24 6.333334,24 L1.666667,24 C1.114382,24 0.666667,23.552285 0.666667,23 L0.666667,1 C0.666667,0.447715 1.114382,0 1.666667,0 Z" transform="translate(-153.000000, -320.000000) translate(153.000000, 320.000000)"/><path d="M13.666667,0 L18.333334,0 C18.885618,0 19.333334,0.447715 19.333334,1 L19.333334,23 C19.333334,23.552285 18.885618,24 18.333334,24 L13.666667,24 C13.114382,24 12.666667,23.552285 12.666667,23 L12.666667,1 C12.666667,0.447715 13.114382,0 13.666667,0 Z" transform="translate(-153.000000, -320.000000) translate(153.000000, 320.000000)"/></g></g></g></svg>
    <svg v-if="audioIcon === 'replay'" class="replay-button" svg-inline="" @click="replayEpisode" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 40 44"><defs><path id="ic_replay_blue_svg__a" d="M17.2802001,31.1473435 C16.7584662,31.5390313 16.0710801,31.6105108 15.4833763,31.3341905 C14.8956726,31.0578702 14.4995829,30.4769738 14.448,29.8157299 L14.448,16.4995939 C14.4995829,15.83835 14.8956726,15.2574536 15.4833763,14.9811333 C16.0710801,14.704813 16.7584662,14.7762925 17.2802001,15.1679803 L26.7160009,21.8260483 C27.1583473,22.1167487 27.4259203,22.6186422 27.4259203,23.1576619 C27.4259203,23.6966816 27.1583473,24.1985751 26.7160009,24.4892755 L17.2802001,31.1473435 Z"/></defs><g fill="none" fill-rule="evenodd"><g><g transform="translate(-595.000000, -200.000000) translate(595.406000, 200.043583)"><path fill="#AFE7F1" d="M19.5613044,43.344 C30.3474247,43.344 39.1225044,34.6205 39.1225044,23.8979621 C39.1225044,18.9986762 37.2823071,14.3166378 33.940987,10.7144563 C30.6028016,7.11589025 26.0708025,4.91502381 21.1798755,4.51742804 L19.8815704,4.41183494 L19.8815704,-3.55271368e-15 L10.9786979,5.31527801 L19.8815704,10.630556 L19.8815704,6.11387235 L21.4359839,6.27593064 C25.7880489,6.72977892 29.8073089,8.76646032 32.7532337,12.0107099 C35.7176535,15.27527 37.3502265,19.4968672 37.3502265,23.8979621 C37.3502265,33.6683544 29.3701171,41.617186 19.5613044,41.617186 C9.7524918,41.617186 1.77238239,33.6683544 1.77238239,23.8979621 C1.77238239,19.3387434 3.50683442,15.0075123 6.65620391,11.702225 C6.81461281,11.5359132 6.89862386,11.3195164 6.89266785,11.0929113 C6.88671185,10.8654555 6.79099776,10.6529932 6.62318464,10.4946567 C6.45004247,10.3313224 6.22810283,10.2502933 6.00668564,10.2502933 C5.76949026,10.2502933 5.53302632,10.3432322 5.35748084,10.527515 C1.90268311,14.1534098 -1.42108547e-14,18.9018028 -1.42108547e-14,23.8979621 C-1.42108547e-14,34.6205 8.77518414,43.344 19.5613044,43.344"/><use fill="#00AECB" xlink:href="#ic_replay_blue_svg__a"/></g></g></g></svg>
    <i
      v-if="isLoading"
      class="el-icon-loading text-blue"/>
  </div>
</template>

<script>
import SegmentEvent from '../../../services/PlayerEvent';

export default {
  props: {
    episode: {
      type: Object,
      default() {
        return {};
      },
    },
    episodeLegacy: {
      type: Object,
      default() {
        return {};
      },
    },
    playlistType: {
      type: String,
      default: 'show',
    },
  },
  data() {
    return {
      episode_was_played: false,
      eventProvider: new SegmentEvent(),
    };
  },
  computed: {
    episodeProgress() {
      const progress = this.$store.getters.episodeProgressByUuid(this.episode.id);

      if (progress) {
        return progress.progress_percent;
      }
      return 0;
    },
    audioIcon() {
      if (this.isLoading) {
        return null;
      }

      if (this.isPlaying) {
        return 'pause';
      }

      if (this.episodeListened && !this.isPlaying) {
        return 'replay';
      }

      return 'play';
    },
    isLoading() {
      const { status } = this.$store.getters;
      return status === 'loading' && this.$store.getters.episode && (this.$store.getters.episode.uuid === this.episode.id);
    },
    isPlaying() {
      const currentlyPlayingEpisode = this.$store.getters.episode;
      const playing = this.$store.getters.play;

      return playing && (currentlyPlayingEpisode && (currentlyPlayingEpisode.uuid === this.episode.id));
    },
    episodeListened() {
      if (this.episode) {
        const progress = this.$store.getters.episodeProgressByUuid(this.episode.id);

        if (progress) {
          return progress.progress_percent >= 95;
        }
        return false;
      }
      return false;
    },
  },
  methods: {
    playEpisode() {
      const trailerAsEpisode = this.episode.type === 'trailer' || this.episode.is_trailer_in_episodes;
      this.$store.dispatch('setTrailerAsEpisode', trailerAsEpisode);

      if (trailerAsEpisode) {
        this.episode.is_trailer_in_episodes = true;
      }

      this.episode_was_played = false;
      this.$store.dispatch('setPlaylistType', this.playlistType);

      const currentEpisode = this.$store.getters.episode;

      if (currentEpisode.uuid === this.episode.id && !trailerAsEpisode) {
        this.$store.dispatch('play');
        this.eventProvider.triggerEpisodePlayEvent(this.episodeLegacy, 'resume_episode');
      } else {
        this.loadMediaInPlayer(this.episode.mediaUrl, this.episode.isExclusive, this.episode.type, trailerAsEpisode);
        if (currentEpisode && currentEpisode.uuid) {
          this.eventProvider.triggerEpisodePauseEvent(currentEpisode, 'episode_select');
        }
        this.$store.dispatch('setAndPlayEpisode', this.episodeLegacy);
        this.eventProvider.triggerEpisodePlayEvent(this.episodeLegacy, 'press_play');
      }
      this.$store.commit('setContinuousListeningActivePodcast', this.episode.showId);
    },
    pauseEpisode() {
      this.episode_was_played = false;
      this.$store.dispatch('pause');
      this.eventProvider.triggerEpisodePauseEvent(this.episodeLegacy, 'pause');
    },
    replayEpisode() {
      this.$store.dispatch('setProgress', 0);
      this.playEpisode();
    },
  },
};
</script>

<style lang="scss" scoped>
.show-play-button {
  position: relative;
  display: flex;
  align-items: center;
  min-width: 46px;
  width: 46px;
  svg {
    cursor: pointer;
  }
  .play-button {
    position: absolute;
    left: 13px;
    width: 20px;
    height: 20px;
  }
  .pause-button {
    position: absolute;
    left: 13px;
    width: 16px;
    height: 16px;
  }
  .replay-button {
    width: 46px;
    height: 46px;
  }
  i {
    position: absolute;
    left: 11px;
    font-size: 20px;
  }
}
</style>
